import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateJobNotificationController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';

function CreateJobNotification({ jobNotification, onClose, onSuccess, JobID }) {
    const { t } = useTranslation(); // Initialize the useTranslation hook
    const [formData, setFormData] = useState({ FK_Issue_ID: JobID, vc_Name: "", vc_Email: "" });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") { // Corrected the comparison operator
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (jobNotification) {
            setFormData({ FK_Issue_ID: JobID, vc_Name: jobNotification.vc_Name, vc_Email: jobNotification.vc_Email });
        } else {
            setFormData({ FK_Issue_ID: JobID, vc_Name: "", vc_Email: "" }); // Clear form data when switching to add mode
        }
    }, [jobNotification]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (jobNotification) {
            formData.ID = jobNotification.PK_Notification_ID;
        } else {
            formData.ID = 0;
        }
        formData.FK_Issue_ID = JobID;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };

        handleSubmit(event, formData, setFormData, setErrors, () => {
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            onSuccess();
            // redirectUserList();
        }, () => {
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            onSuccess();
            // redirectUserList();
        });

    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade jobNotificationModal show d-block" id="jobNotificationModal" tabIndex="-1" aria-labelledby="jobNotificationModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                            bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{jobNotification ? "Edit Notification" : "Add Notification"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ "maxHeight": "300px", "overflow": "auto" }}>
                                    <div className="row mb-3" style={{ marginLeft: "-5px",marginTop:"10px" }}>
                                        <div className="col-sm-12">
                                            <table style={{ width: "100%" }}>
                                                <tbody>


                                                    <tr>
                                                        <td style={{ width: "13%" }}> <label htmlFor="vc_Name" style={{ float: "right" }}>Name <span style={{ "color": "red" }}>*</span></label>
                                                        </td>
                                                        <td style={{ width: "37%" }}>
                                                            <input type="text" className="form-control" name="vc_Name" value={formData.vc_Name} onChange={handleFieldChange} />
                                                            {errors.vc_Name && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Name}</div>}
                                                        </td>
                                                        <td style={{ width: "13%" }}>
                                                            <label htmlFor="vc_Email" style={{ float: "right" }}>Email &nbsp;&nbsp;</label>
                                                        </td>
                                                        <td style={{ width: "37%" }}>
                                                            <input type="text" className="form-control" name="vc_Email" value={formData.vc_Email} onChange={handleFieldChange} />
                                                            {errors.vc_Email && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Email}</div>}
                                                        </td>


                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                      <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />   {jobNotification ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateJobNotification;
